var map = {
	"./item-0.png": 1513,
	"./item-1.png": 1514,
	"./item-2.png": 1515,
	"./item-3.png": 1516,
	"./item-4.png": 1517,
	"./item-5.png": 1518,
	"./item-6.png": 1519,
	"./item-7.png": 1520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1135;